<div *ngIf="hasNotifications" class="notificationDs__cont notificationDs__cont--{{size}}">
  <ng-container *ngIf="enabledContent">
    <div class="notification notification--{{size}}">
      <ng-container *ngIf="showNotificationsIcon">
        <app-ds-icon
          [icon]="iconNotification"
          [color]="iconColor"
          [size]="iconSize">
        </app-ds-icon>
      </ng-container>
      <ng-container *ngIf="showNumberOfNotifications">
        <div class="number-of-notifications">
          <app-ds-typography
            [size]="numberFontSize"
            [fontFamily]="fontFamily"
            [text]="notifications">
          </app-ds-typography>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
